import DeleteModal from './DeleteModal';
import AddProduct from './AddProduct';
import Inventory from './Inventory';
import OrderPage from './OrderPage';
import EditModal from './EditModal';
import LinkModal from './LinkModal';
import ViewMore from './ViewMore';
import AddStock from './AddStock';
import EditStock from './EditStock';
import Checkout from './Checkout';
import AddVariationMain from './AddVariationMain';
import SplitPayment from './SplitPayment';
import ActivityTrail from './ActivityTrial';
import UpdateQty from './UpdateQty';
import ViewMoreStock from './ViewMoreStock';
import AddRateCard from './AddRateCard';
import UpdateRateCard from './UpdateRateCard';
import AddBulkProducts from './AddBulkProducts';

export {
    Inventory,
    OrderPage,
    Checkout,
    DeleteModal,
    EditModal,
    LinkModal,
    SplitPayment,
    ViewMore,
    AddBulkProducts,
    AddRateCard,
	UpdateRateCard,
    EditStock,
    AddProduct,
    AddStock,
    AddVariationMain,
    ActivityTrail,
    UpdateQty,
    ViewMoreStock,
};
